var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{on:{"click":_vm.downloadData}},[_c('span',{staticClass:"mr-2"},[_vm._v("Download Data File")]),_c('v-icon',[_vm._v("mdi-download")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }